"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepositoriesGrid = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const core_1 = require("../../core");
const helpers_1 = require("./helpers");
require("./types");
const core_2 = require("@veeam/core");
const RepositoriesGrid = ({ dataGridModel, displayedColumns, texts, dataGridConfig, dataGridTexts, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const { t } = core_1.useFeatureContext();
    const columns = helpers_1.getColumns({
        region: (_a = displayedColumns === null || displayedColumns === void 0 ? void 0 : displayedColumns.region) !== null && _a !== void 0 ? _a : true,
        encryption: (_b = displayedColumns === null || displayedColumns === void 0 ? void 0 : displayedColumns.encryption) !== null && _b !== void 0 ? _b : true,
        folder: (_c = displayedColumns === null || displayedColumns === void 0 ? void 0 : displayedColumns.folder) !== null && _c !== void 0 ? _c : true,
        description: (_d = displayedColumns === null || displayedColumns === void 0 ? void 0 : displayedColumns.description) !== null && _d !== void 0 ? _d : true,
    }, {
        name: ((_e = texts === null || texts === void 0 ? void 0 : texts.columns) === null || _e === void 0 ? void 0 : _e.name) || t('repositories|grid|columns|name|title'),
        region: ((_f = texts === null || texts === void 0 ? void 0 : texts.columns) === null || _f === void 0 ? void 0 : _f.region) || t('repositories|grid|columns|region|title'),
        encryption: ((_g = texts === null || texts === void 0 ? void 0 : texts.columns) === null || _g === void 0 ? void 0 : _g.encryption) || t('repositories|grid|columns|encryption|title'),
        folder: ((_h = texts === null || texts === void 0 ? void 0 : texts.columns) === null || _h === void 0 ? void 0 : _h.folder) || t('repositories|grid|columns|folder|title'),
        description: ((_j = texts === null || texts === void 0 ? void 0 : texts.columns) === null || _j === void 0 ? void 0 : _j.description) || t('repositories|grid|columns|description|title'),
    }, {
        trueValue: ((_k = texts === null || texts === void 0 ? void 0 : texts.columns) === null || _k === void 0 ? void 0 : _k.description) || t('repositories|grid|columns|encryption|trueValue'),
        falseValue: ((_l = texts === null || texts === void 0 ? void 0 : texts.columns) === null || _l === void 0 ? void 0 : _l.description) || t('repositories|grid|columns|encryption|falseValue'),
    });
    const dataGridModelValue = core_2.useModel(dataGridModel);
    const searchValue = dataGridModelValue.value.filters.getFilterValue('name');
    const isSearch = typeof searchValue === 'string' && !!searchValue;
    const defaultDataGridTexts = Object.assign(Object.assign({}, dataGridTexts), { empty: isSearch ? undefined : (dataGridTexts === null || dataGridTexts === void 0 ? void 0 : dataGridTexts.empty) || t('repositories|grid|empty') });
    return (react_1.default.createElement(components_1.DataGrid, { model: dataGridModel, toolbar: {
            items: [
                components_1.toolbarSearchFilter({
                    property: helpers_1.REPOSITORIES_FILTER_KEY.search,
                    fieldConfig: {
                        placeholder: ((_m = texts === null || texts === void 0 ? void 0 : texts.search) === null || _m === void 0 ? void 0 : _m.placeholder) || t('repositories|grid|search|placeholder'),
                        size: components_1.CONTROL_SIZE.l,
                    },
                }),
            ],
        }, columns: columns, config: Object.assign({ autoLoad: true, canResizeColumns: true, columnsToggleable: false, selection: {
                multi: false,
            } }, dataGridConfig), texts: defaultDataGridTexts }));
};
exports.RepositoriesGrid = RepositoriesGrid;
//# sourceMappingURL=RepositoriesGrid.js.map